export default __webpack_public_path__ + "static/media/emoji-facebook.cc1cf528.svg";